import AudiencePage from "../components/marketing/AudiencePage";
import { SHOTS } from "../components/marketing/features";

const STEPS = [
  { title: "Build your team", tier: "free", shot: SHOTS.roster,
    body: "Add your players or import a list, then share a join code or invite parents by email. Free teams hold up to 15 players." },
  { title: "Schedule with a safety net", tier: "free", shot: SHOTS.conflict,
    body: "Add practices and games. If a new or moved event overlaps another one on your team, Chalk OS warns you before families see it." },
  { title: "Run game day from the Chalkboard", tier: "free", shot: SHOTS.chalkboard,
    body: "Your next play, who's going, and one-tap buttons to message families or Erase and Redraw a single event." },
  { title: "Change a whole stretch at once", tier: "board", shot: SHOTS.bulk,
    body: "Bulk Erase and Redraw cancels, delays or shifts every event in a date range. Each family gets one combined alert listing every change, not one per event." },
  { title: "Let Draw It Up write it", tier: "board", shot: SHOTS.drawItUp,
    body: "Pick a vibe like Game day reminder, add a detail, and get a draft in your voice. You review it, then post it to Chalk Talk." },
];

export default function Coaches() {
  return (
    <AudiencePage
      id="coaches" docTitle="Chalk OS for coaches: schedule, Erase and Redraw, Chalk Talk"
      eyebrow="For coaches & captains" title="Coach the team." marker="Not the group text."
      intro="One place for your schedule, RSVPs, last-minute changes and team messages. Families get the update the moment you tap."
      steps={STEPS} featureTitle="Everything a coach uses." featureSub="Free first. Chalkboard when you need more."
      features={["schedule", "rsvp", "singleRedraw", "coachConflicts", "chalkTalk", "roster", "staff", "files", "archive",
                 "bulkRedraw", "drawItUp", "recurring", "volunteers", "targeting", "multiGuardian", "rosterExport"]}
    />
  );
}
